import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.26.8_supports-color@8.1.1__@opentelemetry+api@1.9.0_@playwrig_c7508f64184ae49e181ff42d247351bd/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/AppWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/template/BlogDetailTemplate/BlogDetailTemplate.tsx");
